import { TitreDescriptionMenuVisuel } from '@components/titre-description-menu-visuel/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const titreDescriptionMenuVisuelMock: Block<TitreDescriptionMenuVisuel> = {
  type: 'titre-description-menu-visuel',
  data: {
    title: {
      text: `les tendances [[Socoo'c]]`,
      as: 'h1',
    },
    description: `Parce qu'un projet est un travail d'équipe, nous vous conseillons et vous accompagnons à chaque étape de la réalisation de votre cuisine.`,
    items: [
      {
        image: imageMock,
        cta: {
          label: `Tous nos modèles`,
          url: '/mock-nos-modeles',
        },
      },
      {
        image: imageMock,
        cta: {
          label: `Les cuisines de nos clients`,
          url: '/mock-les-cuisines-de-nos-clients',
        },
      },
    ],
  },
};
